import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { BlackButtonComponent, WhiteButtonComponent } from "components/index";

interface ConfirmNotedDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  tripTitle: string;
}

const ConfirmNotedDialog = (props: ConfirmNotedDialogProps) => {
  const { open, onConfirm, onCancel, tripTitle } = props;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h6" fontWeight="600">
            Mark Booking as Noted
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          <Typography variant="body1" mb={2}>
            Are you sure you want to mark this booking as noted?
          </Typography>
          <Typography variant="body2" sx={{ backgroundColor: "#F5F5F5", p: 2, borderRadius: "8px" , fontWeight: 700}}>
            <strong>Trip:</strong> {tripTitle}
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" mt={2}>
            ⚠️ Once marked as noted, this action cannot be undone.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
       <WhiteButtonComponent onClick={onCancel} btnText="Cancel" />
       <BlackButtonComponent onClick={onConfirm} btnText="Confirm" />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmNotedDialog;
